import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import fetchTaskUserImage from 'actions/ProfilePicture';
import {
  COMPLETED,
  ONGOING,
  PAUSED,
  ACT1,
  ACT7,
  ACT9,
  ACT10,
  ACT11,
  ACT12,
  ACT13,
  ACT16,
  ACT18,
  ACT20,
  ACT28,
  ACT30,
  ACT31,
  ACT32
} from 'constants/index';
import { SecondsTohoursMinutes, GetValuesFromDate, ParseISOString, PadString } from 'utils/index';
import { Box, Typography, List, ListItem, Checkbox } from '@mui/material';
import * as fieldListStyle from '../../fields/fieldtab/FieldListStyle';

class TaskListItem extends Component {
  /**
   * To pass object the checked status of the item
   * @param {object} e div element object
   */
  checkBoxChange = e => {
    const { handleCheckbox } = this.props;
    handleCheckbox(e);
  };

  /**
   * get the time formate to display
   *
   */
  getDurationFormate = () => {
    const { TaskDetails } = this.props;
    if (TaskDetails.netDuration) {
      const hrsMin = SecondsTohoursMinutes(TaskDetails.netDuration);
      return `${PadString(hrsMin.hours)} hrs ${PadString(hrsMin.minutes)} min`;
    }
    return null;
  };

  /**
   * get the end-time formate to display
   *
   */
  getEndTime = () => {
    const { TaskDetails } = this.props;
    if (TaskDetails.endTime) {
      const tempEndDateTime = TaskDetails.endTime
        ? GetValuesFromDate(new Date(ParseISOString(TaskDetails.endTime)))
        : { date: '', time: '' };
      return tempEndDateTime.date;
    }
    return null;
  };

  getAmount = () => {
    const { TaskDetails } = this.props;
    if (TaskDetails.taskActivity) {
      const amountUnit = TaskDetails.taskActivity;
      switch (amountUnit.activityId) {
        case ACT9:
        case ACT10:
        case ACT28:
          return {
            amount: amountUnit.cutAmount ? amountUnit.cutAmount : null,
            unit: amountUnit.cutUnit
          };
        case ACT11:
        case ACT12:
        case ACT16:
        case ACT18:
          return {
            amount: amountUnit.cutAmount ? amountUnit.cutAmount : null,
            unit: <FormattedMessage id="TASK_DYNAMIC_HARVEST_UNIT" />
          };
        case ACT20:
          return {
            amount: amountUnit.comboFertiAmount ? amountUnit.comboFertiAmount : null,
            unit: amountUnit.comboFertiUnit
          };
        case ACT13:
          return {
            amount: amountUnit.totalHarvest ? amountUnit.totalHarvest : null,
            unit: 'kg/daa'
          };
        case ACT1:
        case ACT7:
        case ACT30:
        case ACT31:
        case ACT32:
          return { amount: amountUnit.amount ? amountUnit.amount : null, unit: amountUnit.unit };
        default:
          return null;
      }
    }
    return null;
  };

  render() {
    const { TaskDetails, checked, isLoading, hasPermission, intl, handleOpenModalWindow, handleCheckbox, index } = this.props;
    const status = TaskDetails.status ? TaskDetails.status.toUpperCase() : null;
    const amountAndUnit = this.getAmount();
    const isDisabled = isLoading && 'disable';
    let seasonName = null;
    if (TaskDetails.seasonId) {
      if (TaskDetails.seasonId === 1) {
        seasonName = intl.formatMessage({ id: 'CHOOSE_FERTILIZATION' });
      } else if (TaskDetails.seasonId === 2) {
        seasonName = intl.formatMessage({ id: 'CHOOSE_FIRST_HARVEST' });
      } else if (TaskDetails.seasonId === 3) {
        seasonName = intl.formatMessage({ id: 'CHOOSE_SECOND_HARVEST' });
      } else if (TaskDetails.seasonId === 4) {
        seasonName = intl.formatMessage({ id: 'CHOOSE_THIRD_HARVEST' });
      } else {
        seasonName = null;
      }
    }

    let cut = null;
    if (TaskDetails.taskActivity.cut) {
      if (TaskDetails.taskActivity.cut === 1) {
        cut = "1. slått";
      } else if (TaskDetails.taskActivity.cut === 2) {
        cut = "2. slått";
      } else if (TaskDetails.taskActivity.cut === 3) {
        cut = "3. slått";
      } else if (TaskDetails.taskActivity.cut === 4) {
        cut = "4. slått";
      } else {
        cut = null;
      }
    }

    return (
      <li
        className="show-checkbox list-item full-width"
        key={TaskDetails.id}
        style={{
          padding: '0px', // Remove padding from li
          height: '72px', // Match header height
          display: 'flex',
          alignItems: 'center',
          backgroundColor: '#fff',
          boxSizing: 'border-box', // Ensure consistent width calculation
          marginTop: index === 0 ? '400px' : '0px', // Apply marginTop conditionally
        }}
      >
        <Box
          sx={{
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
          }}
        >
          <Box
            sx={{
              width: '100%',
              display: 'flex',
              alignItems: 'center',
              borderBottom: '1px solid #BEC8C9',
              height: '100%',
              marginLeft: '16px',
              marginRight: '24px',
              boxSizing: 'border-box',
            }}
          >
            {/* Checkbox */}
            <div
              style={{
                width: '40px',
                flexShrink: 0,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                marginRight: '16px'
              }}
            >
              <Checkbox
                checked={checked}
                onChange={(e) => handleCheckbox(e, TaskDetails.id)}
                sx={{
                  color: '#000',
                  '&.Mui-checked': { color: '#00696D' },
                  padding: '0px', // Match header exactly
                }}
              />
            </div>

            {/* Left column - Activity Registration */}
            <Box
              onClick={() => handleOpenModalWindow(TaskDetails.id)}
              sx={{
                flex: 2,
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                cursor: 'pointer',
              }}
            >
              <Typography sx={fieldListStyle.listRowSubItem}>
                {seasonName !== null ? seasonName : cut}
              </Typography>
              <Typography sx={fieldListStyle.listRowItem}>
                {TaskDetails.activityId ? TaskDetails.activityName : <FormattedMessage id="NOT_DEFINED" />}
              </Typography>
            </Box>

            {/* Right column - Field Name */}
            <Box
              sx={{
                flex: 1,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-end',
                boxSizing: 'border-box',
              }}
            >
              <Typography
                sx={{
                  color: '#191C1C',
                  fontFamily: 'Inter',
                  fontSize: '11px',
                  fontWeight: 500,
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  maxWidth: '180px',
                }}
              >
                {TaskDetails.fieldId ? TaskDetails.fieldName : <FormattedMessage id="NOT_DEFINED" />}
              </Typography>
            </Box>
          </Box>
        </Box>
      </li>
    );
  }
}

const mapStateToProps = state => ({
  /*AWSLoginDetails: state.AWSLogin.data,*/
  profilePictures: state.profileImage.userImage
});

const mapDispatchToProps = dispatch => ({
  getTaskUserImage: (AWSLogin, type, id, userType) => dispatch(fetchTaskUserImage(AWSLogin, type, id, userType))
});

export default connect(mapStateToProps, mapDispatchToProps)(TaskListItem);